import axios from 'axios'
import { ref } from 'vue'
import { APIS_SERVER, TIMEOUTTIME } from '@/constants/apis'
import { showConsoleError } from '@/functions/errors'
import { VIRMAC } from '@/interfaces/SmartLink/Server';
import { EQUIPAMENTS } from '@/interfaces/SmartLink/Equips';
import { EQUIPOS, PARAMETROS, VIRTUAL_MACHINES, VIRTUAL_MACHINES_ARRAY } from '@/interfaces/SmartLink/Equipos';
import { TOKEN } from '@/constants/labels';

export async function getIPServerData() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_SERVER.value.getIPServer, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<string[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalData.forEach((item: EQUIPAMENTS) => {
          item.ip ? finalObj.value.push(item.ip) : null
        })
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}




export async function getVirMacServerByIP(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_SERVER.value.getVirMacServer, { params: params, timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<VIRMAC[]>([])
      const showGraphs = ref(finalData.length > 0)
      let virMacON = 0;
      if (finalData.length > 0) {
        // Convierte a JSON la variable "info_mv"
        const virtualMachines = JSON.parse(finalData[0].info_mv ?? '{}');

        // Captura los valores de cada llave del JSON y los agrega al Array
        const arrayDeObjetos: VIRTUAL_MACHINES_ARRAY = Object.values(virtualMachines);
        arrayDeObjetos[0].forEach((item: VIRTUAL_MACHINES) => {
          const mv = item.name;
          const CPUFisico = item.CPUFisico ?? 0;
          const CPUActual = item.CPUActual ?? 0;
          const MemoriaFisico = parseFloat(((item.MemoriaFisico ?? 0) / 1024).toFixed(2));
          const MemoriaActual = item.MemoriaActual ?? 0;
          const DiscoFisico = parseFloat((item.DiscoFisico ?? 0).toFixed(2));
          const DiscoActual = item.DiscoActual ?? 0;
          const porcDisco = ((DiscoActual / DiscoFisico) * 100);
          const porcMemor = ((MemoriaActual / (MemoriaFisico * 1024)) * 100);
          const porcCPU = ((CPUActual / (CPUFisico * 1024)) * 100);
          const dispDisco = (100 - porcDisco).toFixed(2);
          const dispMemor = (100 - porcMemor).toFixed(2);
          const dispCPU = (100 - porcCPU).toFixed(2);
          CPUActual !== 0 ? virMacON = virMacON + 1 : null;
          const finalItem: VIRMAC = {
            mv: mv,
            porcDisco: porcDisco,
            porcMemor: porcMemor,
            porcCPU: porcCPU,
            CPUActual: CPUActual,
            dispDisco: dispDisco,
            dispMemor: dispMemor,
            dispCPU: dispCPU,
          }
          finalObj.value.push(finalItem)
        })
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}